import { MenuSub, type MenuSubProps } from '@affine/component';
import { useRef } from 'react';

import { STREAMLAIN_DROPDOWN_MENU_OFFSET } from './chrome';
import { RadixDropdownPanelChrome } from './radix-chrome';

/**
 * Radix submenu with the same StreamLain disclosure chrome as top-level menus.
 * The submenu trigger ref keeps the tail and grow animation anchored to the
 * row that opened this panel.
 */
export function StreamLainMenuSub({
  items,
  subContentOptions,
  ...props
}: MenuSubProps) {
  const triggerRef = useRef<HTMLDivElement | null>(null);

  return (
    <MenuSub
      {...props}
      triggerRef={triggerRef}
      subContentOptions={{
        collisionPadding: 8,
        sideOffset: STREAMLAIN_DROPDOWN_MENU_OFFSET,
        ...subContentOptions,
      }}
      items={
        <RadixDropdownPanelChrome triggerRef={triggerRef}>
          {items}
        </RadixDropdownPanelChrome>
      }
    />
  );
}
